import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CalendarWeekView = ({
  calendarData,
  selectedDate,
  isSameDay,
  getFirstDayOfWeek,
  getShipmentBackgroundColor,
  getShipmentStatusText,
  getTransportIcon,
  handleShipmentClick,
  isShipmentCritical,
  isShipmentDelayed,
  isShipmentUpcoming,
}) => {
  // Generate header dates for the week
  const generateWeekDays = () => {
    const days = [];
    const firstDayOfWeek = getFirstDayOfWeek(selectedDate);

    for (let i = 0; i < 7; i++) {
      const day = new Date(firstDayOfWeek);
      day.setDate(day.getDate() + i);
      days.push(day);
    }

    return days;
  };

  const weekDays = generateWeekDays();

  return (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      {/* Week view header (days with dates) */}
      <div className="grid grid-cols-7 bg-gray-100">
        {weekDays.map((day, index) => (
          <div
            key={index}
            className={`p-3 text-center text-sm font-medium ${
              isSameDay(day, new Date()) ? "bg-blue-100" : ""
            } border-r last:border-r-0`}
          >
            <div>{day.toLocaleDateString([], { weekday: "short" })}</div>
            <div
              className={`mt-1 ${
                isSameDay(day, new Date())
                  ? "bg-blue-600 text-white rounded-full w-6 h-6 inline-flex items-center justify-center"
                  : ""
              }`}
            >
              {day.getDate()}
            </div>
          </div>
        ))}
      </div>

      {/* Week view content */}
      <div className="grid grid-cols-7 min-h-[500px]">
        {calendarData.map((day) => (
          <div
            key={day.date.toISOString()}
            className={`border p-2 ${
              isSameDay(day.date, new Date()) ? "bg-blue-50" : ""
            }`}
          >
            {/* Shipments for this day */}
            <div className="space-y-2 overflow-y-auto max-h-[450px]">
              {day.shipments.map((shipment) => (
                <div
                  key={shipment.header.reference}
                  className={`p-2 rounded border-l-4 ${
                    isShipmentCritical(shipment)
                      ? "border-l-red-500"
                      : isShipmentDelayed(shipment)
                      ? "border-l-amber-500"
                      : isShipmentUpcoming(shipment)
                      ? "border-l-blue-500"
                      : "border-l-green-500"
                  } ${getShipmentBackgroundColor(
                    shipment
                  )} cursor-pointer hover:shadow-md transition-shadow`}
                  onClick={() => handleShipmentClick(shipment)}
                >
                  <div className="flex justify-between items-center">
                    <span className="font-medium">
                      {shipment.header.reference}
                    </span>
                    <FontAwesomeIcon
                      icon={
                        getTransportIcon(
                          shipment.header.pedimento?.pedimento_entry_point
                        ).icon
                      }
                      className={
                        getTransportIcon(
                          shipment.header.pedimento?.pedimento_entry_point
                        ).color
                      }
                    />
                  </div>
                  <div className="text-xs mt-1 text-gray-600 truncate">
                    {shipment.header.customer_name}
                  </div>
                  <div className="text-xs mt-1 flex justify-between">
                    <span className="font-medium">
                      {getShipmentStatusText(shipment)}
                    </span>
                    {shipment.header.pedimento?.pedimento_number && (
                      <span className="truncate">
                        Ped: {shipment.header.pedimento.pedimento_number}
                      </span>
                    )}
                  </div>
                </div>
              ))}
              {day.shipments.length === 0 && (
                <div className="text-center text-gray-400 text-sm mt-4">
                  No shipments
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CalendarWeekView;
